export const modeTypes = {
  NONE: 0,
  SINGLE: 1,
};
